"use client";

import { useState } from "react";
import { Box, Typography, styled } from "@mui/material";
import {
  RightColumn,
  SectionHeader,
  SectionContent,
  Label,
  Value,
} from "./styles/SharedStyles";
import EditSummary from "../modals/EditSummary";
import EditButton from "@components/shared/EditButton";
import { SummarySkeleton } from "./skeletons";

const SummarySection = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: "8px",
  marginBottom: theme.spacing(3),
  "&:last-child": {
    marginBottom: 0,
  },
}));

const Summary = ({ candidate, onUpdate, isImporting }) => {
  const [openEditSummary, setOpenEditSummary] = useState(false);
  return (
    <>
      <Box id="candidate-section-summary">
        <SectionContent>
          <EditButton
            onEdit={() => setOpenEditSummary(true)}
            sx={{ top: 0, right: 0 }}
          />
          <Box>
            <RightColumn>
              <SectionHeader>
                <Typography variant="h2">Summary</Typography>
              </SectionHeader>
              {isImporting ? (
                <SummarySkeleton />
              ) : (
                <>
                  <SummarySection>
                    <Label>Highlights:</Label>
                    <Value>{candidate.highlights}</Value>
                  </SummarySection>
                  <SummarySection>
                    <Label>Short introduction:</Label>
                    <Value>{candidate.summary}</Value>
                  </SummarySection>
                  <SummarySection>
                    <Label>Long introduction:</Label>
                    <Value>{candidate.introduction}</Value>
                  </SummarySection>
                </>
              )}
            </RightColumn>
          </Box>
        </SectionContent>
      </Box>
      <EditSummary
        onClose={() => setOpenEditSummary(false)}
        open={openEditSummary}
        candidate={candidate}
        onUpdate={onUpdate}
      />
    </>
  );
};

export default Summary;
